// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessconflict/v1/accessconflict.proto" (package "c1.api.accessconflict.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchRequest
 */
export interface ConflictMonitorSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitorRef refs = 3
     */
    refs: ConflictMonitorRef[];
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchResponse
 */
export interface ConflictMonitorSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitor list = 1
     */
    list: ConflictMonitor[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsRequest
 */
export interface ConflictMonitorSearchWithCountsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitorRef refs = 3
     */
    refs: ConflictMonitorRef[];
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsResponse
 */
export interface ConflictMonitorSearchWithCountsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitorView list = 1
     */
    list: ConflictMonitorView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorGetRequest
 */
export interface ConflictMonitorGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorDeleteRequest
 */
export interface ConflictMonitorDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorDeleteResponse
 */
export interface ConflictMonitorDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorListRequest
 */
export interface ConflictMonitorListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorListWithCountsRequest
 */
export interface ConflictMonitorListWithCountsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorView
 */
export interface ConflictMonitorView {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.ConflictMonitor monitor = 1
     */
    monitor?: ConflictMonitor;
    /**
     * @generated from protobuf field: int64 violation_count = 2
     */
    violationCount: number;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorListResponse
 */
export interface ConflictMonitorListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitor list = 1
     */
    list: ConflictMonitor[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorListWithCountsResponse
 */
export interface ConflictMonitorListWithCountsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.accessconflict.v1.ConflictMonitorView list = 1
     */
    list: ConflictMonitorView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorCreateRequest
 */
export interface ConflictMonitorCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.NotificationConfig notification_config = 3
     */
    notificationConfig?: NotificationConfig;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorUpdateRequest
 */
export interface ConflictMonitorUpdateRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.NotificationConfig notification_config = 4
     */
    notificationConfig?: NotificationConfig;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorEnableRequest
 */
export interface ConflictMonitorEnableRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: bool enabled = 2
     */
    enabled: boolean;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorForceRunRequest
 */
export interface ConflictMonitorForceRunRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.SlackNotifications
 */
export interface SlackNotifications {
    /**
     * @generated from protobuf field: bool enabled = 1
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: string channel_name = 2
     */
    channelName: string;
    /**
     * @generated from protobuf field: string channel_id = 3
     */
    channelId: string;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.EmailNotifications
 */
export interface EmailNotifications {
    /**
     * @generated from protobuf field: bool enabled = 1
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: repeated string identity_user_ids = 2
     */
    identityUserIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.NotificationConfig
 */
export interface NotificationConfig {
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.EmailNotifications email_notifications = 1
     */
    emailNotifications?: EmailNotifications;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.SlackNotifications slack_notifications = 2
     */
    slackNotifications?: SlackNotifications;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitor
 */
export interface ConflictMonitor {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: string entitlement_set_a_id = 4
     */
    entitlementSetAId: string;
    /**
     * @generated from protobuf field: string entitlement_set_b_id = 5
     */
    entitlementSetBId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 8
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: bool enabled = 9
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: c1.api.accessconflict.v1.NotificationConfig notification_config = 10
     */
    notificationConfig?: NotificationConfig;
}
/**
 * @generated from protobuf message c1.api.accessconflict.v1.ConflictMonitorRef
 */
export interface ConflictMonitorRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorSearchRequest$Type extends MessageType<ConflictMonitorSearchRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitorRef },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorSearchRequest>): ConflictMonitorSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorSearchRequest): ConflictMonitorSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.accessconflict.v1.ConflictMonitorRef refs */ 3:
                    message.refs.push(ConflictMonitorRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.accessconflict.v1.ConflictMonitorRef refs = 3; */
        for (let i = 0; i < message.refs.length; i++)
            ConflictMonitorRef.internalBinaryWrite(message.refs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchRequest
 */
export const ConflictMonitorSearchRequest = new ConflictMonitorSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorSearchResponse$Type extends MessageType<ConflictMonitorSearchResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitor },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorSearchResponse>): ConflictMonitorSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorSearchResponse): ConflictMonitorSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessconflict.v1.ConflictMonitor list */ 1:
                    message.list.push(ConflictMonitor.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessconflict.v1.ConflictMonitor list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConflictMonitor.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchResponse
 */
export const ConflictMonitorSearchResponse = new ConflictMonitorSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorSearchWithCountsRequest$Type extends MessageType<ConflictMonitorSearchWithCountsRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitorRef },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorSearchWithCountsRequest>): ConflictMonitorSearchWithCountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorSearchWithCountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorSearchWithCountsRequest): ConflictMonitorSearchWithCountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.accessconflict.v1.ConflictMonitorRef refs */ 3:
                    message.refs.push(ConflictMonitorRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorSearchWithCountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.accessconflict.v1.ConflictMonitorRef refs = 3; */
        for (let i = 0; i < message.refs.length; i++)
            ConflictMonitorRef.internalBinaryWrite(message.refs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsRequest
 */
export const ConflictMonitorSearchWithCountsRequest = new ConflictMonitorSearchWithCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorSearchWithCountsResponse$Type extends MessageType<ConflictMonitorSearchWithCountsResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitorView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorSearchWithCountsResponse>): ConflictMonitorSearchWithCountsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorSearchWithCountsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorSearchWithCountsResponse): ConflictMonitorSearchWithCountsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessconflict.v1.ConflictMonitorView list */ 1:
                    message.list.push(ConflictMonitorView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorSearchWithCountsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessconflict.v1.ConflictMonitorView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConflictMonitorView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorSearchWithCountsResponse
 */
export const ConflictMonitorSearchWithCountsResponse = new ConflictMonitorSearchWithCountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorGetRequest$Type extends MessageType<ConflictMonitorGetRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorGetRequest>): ConflictMonitorGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorGetRequest): ConflictMonitorGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorGetRequest
 */
export const ConflictMonitorGetRequest = new ConflictMonitorGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorDeleteRequest$Type extends MessageType<ConflictMonitorDeleteRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorDeleteRequest>): ConflictMonitorDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorDeleteRequest): ConflictMonitorDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorDeleteRequest
 */
export const ConflictMonitorDeleteRequest = new ConflictMonitorDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorDeleteResponse$Type extends MessageType<ConflictMonitorDeleteResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorDeleteResponse", []);
    }
    create(value?: PartialMessage<ConflictMonitorDeleteResponse>): ConflictMonitorDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorDeleteResponse): ConflictMonitorDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorDeleteResponse
 */
export const ConflictMonitorDeleteResponse = new ConflictMonitorDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorListRequest$Type extends MessageType<ConflictMonitorListRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorListRequest>): ConflictMonitorListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorListRequest): ConflictMonitorListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorListRequest
 */
export const ConflictMonitorListRequest = new ConflictMonitorListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorListWithCountsRequest$Type extends MessageType<ConflictMonitorListWithCountsRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorListWithCountsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorListWithCountsRequest>): ConflictMonitorListWithCountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorListWithCountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorListWithCountsRequest): ConflictMonitorListWithCountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorListWithCountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorListWithCountsRequest
 */
export const ConflictMonitorListWithCountsRequest = new ConflictMonitorListWithCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorView$Type extends MessageType<ConflictMonitorView> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorView", [
            { no: 1, name: "monitor", kind: "message", T: () => ConflictMonitor },
            { no: 2, name: "violation_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorView>): ConflictMonitorView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.violationCount = 0;
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorView): ConflictMonitorView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessconflict.v1.ConflictMonitor monitor */ 1:
                    message.monitor = ConflictMonitor.internalBinaryRead(reader, reader.uint32(), options, message.monitor);
                    break;
                case /* int64 violation_count */ 2:
                    message.violationCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessconflict.v1.ConflictMonitor monitor = 1; */
        if (message.monitor)
            ConflictMonitor.internalBinaryWrite(message.monitor, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 violation_count = 2; */
        if (message.violationCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.violationCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorView
 */
export const ConflictMonitorView = new ConflictMonitorView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorListResponse$Type extends MessageType<ConflictMonitorListResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitor },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorListResponse>): ConflictMonitorListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorListResponse): ConflictMonitorListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessconflict.v1.ConflictMonitor list */ 1:
                    message.list.push(ConflictMonitor.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessconflict.v1.ConflictMonitor list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConflictMonitor.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorListResponse
 */
export const ConflictMonitorListResponse = new ConflictMonitorListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorListWithCountsResponse$Type extends MessageType<ConflictMonitorListWithCountsResponse> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorListWithCountsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConflictMonitorView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorListWithCountsResponse>): ConflictMonitorListWithCountsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorListWithCountsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorListWithCountsResponse): ConflictMonitorListWithCountsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.accessconflict.v1.ConflictMonitorView list */ 1:
                    message.list.push(ConflictMonitorView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorListWithCountsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.accessconflict.v1.ConflictMonitorView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ConflictMonitorView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorListWithCountsResponse
 */
export const ConflictMonitorListWithCountsResponse = new ConflictMonitorListWithCountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorCreateRequest$Type extends MessageType<ConflictMonitorCreateRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "notification_config", kind: "message", T: () => NotificationConfig }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorCreateRequest>): ConflictMonitorCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorCreateRequest): ConflictMonitorCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.NotificationConfig notification_config */ 3:
                    message.notificationConfig = NotificationConfig.internalBinaryRead(reader, reader.uint32(), options, message.notificationConfig);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* c1.api.accessconflict.v1.NotificationConfig notification_config = 3; */
        if (message.notificationConfig)
            NotificationConfig.internalBinaryWrite(message.notificationConfig, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorCreateRequest
 */
export const ConflictMonitorCreateRequest = new ConflictMonitorCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorUpdateRequest$Type extends MessageType<ConflictMonitorUpdateRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorUpdateRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "notification_config", kind: "message", T: () => NotificationConfig }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorUpdateRequest>): ConflictMonitorUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorUpdateRequest): ConflictMonitorUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* c1.api.accessconflict.v1.NotificationConfig notification_config */ 4:
                    message.notificationConfig = NotificationConfig.internalBinaryRead(reader, reader.uint32(), options, message.notificationConfig);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* c1.api.accessconflict.v1.NotificationConfig notification_config = 4; */
        if (message.notificationConfig)
            NotificationConfig.internalBinaryWrite(message.notificationConfig, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorUpdateRequest
 */
export const ConflictMonitorUpdateRequest = new ConflictMonitorUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorEnableRequest$Type extends MessageType<ConflictMonitorEnableRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorEnableRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorEnableRequest>): ConflictMonitorEnableRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorEnableRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorEnableRequest): ConflictMonitorEnableRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool enabled */ 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorEnableRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool enabled = 2; */
        if (message.enabled !== false)
            writer.tag(2, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorEnableRequest
 */
export const ConflictMonitorEnableRequest = new ConflictMonitorEnableRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorForceRunRequest$Type extends MessageType<ConflictMonitorForceRunRequest> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorForceRunRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorForceRunRequest>): ConflictMonitorForceRunRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorForceRunRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorForceRunRequest): ConflictMonitorForceRunRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorForceRunRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorForceRunRequest
 */
export const ConflictMonitorForceRunRequest = new ConflictMonitorForceRunRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SlackNotifications$Type extends MessageType<SlackNotifications> {
    constructor() {
        super("c1.api.accessconflict.v1.SlackNotifications", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "channel_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "channel_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SlackNotifications>): SlackNotifications {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enabled = false;
        message.channelName = "";
        message.channelId = "";
        if (value !== undefined)
            reflectionMergePartial<SlackNotifications>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SlackNotifications): SlackNotifications {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* string channel_name */ 2:
                    message.channelName = reader.string();
                    break;
                case /* string channel_id */ 3:
                    message.channelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SlackNotifications, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* string channel_name = 2; */
        if (message.channelName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.channelName);
        /* string channel_id = 3; */
        if (message.channelId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.channelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.SlackNotifications
 */
export const SlackNotifications = new SlackNotifications$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmailNotifications$Type extends MessageType<EmailNotifications> {
    constructor() {
        super("c1.api.accessconflict.v1.EmailNotifications", [
            { no: 1, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "identity_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<EmailNotifications>): EmailNotifications {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.enabled = false;
        message.identityUserIds = [];
        if (value !== undefined)
            reflectionMergePartial<EmailNotifications>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EmailNotifications): EmailNotifications {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool enabled */ 1:
                    message.enabled = reader.bool();
                    break;
                case /* repeated string identity_user_ids */ 2:
                    message.identityUserIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EmailNotifications, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool enabled = 1; */
        if (message.enabled !== false)
            writer.tag(1, WireType.Varint).bool(message.enabled);
        /* repeated string identity_user_ids = 2; */
        for (let i = 0; i < message.identityUserIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.identityUserIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.EmailNotifications
 */
export const EmailNotifications = new EmailNotifications$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationConfig$Type extends MessageType<NotificationConfig> {
    constructor() {
        super("c1.api.accessconflict.v1.NotificationConfig", [
            { no: 1, name: "email_notifications", kind: "message", T: () => EmailNotifications },
            { no: 2, name: "slack_notifications", kind: "message", T: () => SlackNotifications }
        ]);
    }
    create(value?: PartialMessage<NotificationConfig>): NotificationConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<NotificationConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: NotificationConfig): NotificationConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.accessconflict.v1.EmailNotifications email_notifications */ 1:
                    message.emailNotifications = EmailNotifications.internalBinaryRead(reader, reader.uint32(), options, message.emailNotifications);
                    break;
                case /* c1.api.accessconflict.v1.SlackNotifications slack_notifications */ 2:
                    message.slackNotifications = SlackNotifications.internalBinaryRead(reader, reader.uint32(), options, message.slackNotifications);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: NotificationConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.accessconflict.v1.EmailNotifications email_notifications = 1; */
        if (message.emailNotifications)
            EmailNotifications.internalBinaryWrite(message.emailNotifications, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.accessconflict.v1.SlackNotifications slack_notifications = 2; */
        if (message.slackNotifications)
            SlackNotifications.internalBinaryWrite(message.slackNotifications, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.NotificationConfig
 */
export const NotificationConfig = new NotificationConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitor$Type extends MessageType<ConflictMonitor> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitor", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 4, name: "entitlement_set_a_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 5, name: "entitlement_set_b_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "deleted_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "notification_config", kind: "message", T: () => NotificationConfig }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitor>): ConflictMonitor {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.entitlementSetAId = "";
        message.entitlementSetBId = "";
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitor>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitor): ConflictMonitor {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string entitlement_set_a_id */ 4:
                    message.entitlementSetAId = reader.string();
                    break;
                case /* string entitlement_set_b_id */ 5:
                    message.entitlementSetBId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 8:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* bool enabled */ 9:
                    message.enabled = reader.bool();
                    break;
                case /* c1.api.accessconflict.v1.NotificationConfig notification_config */ 10:
                    message.notificationConfig = NotificationConfig.internalBinaryRead(reader, reader.uint32(), options, message.notificationConfig);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitor, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string entitlement_set_a_id = 4; */
        if (message.entitlementSetAId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.entitlementSetAId);
        /* string entitlement_set_b_id = 5; */
        if (message.entitlementSetBId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.entitlementSetBId);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 8; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool enabled = 9; */
        if (message.enabled !== false)
            writer.tag(9, WireType.Varint).bool(message.enabled);
        /* c1.api.accessconflict.v1.NotificationConfig notification_config = 10; */
        if (message.notificationConfig)
            NotificationConfig.internalBinaryWrite(message.notificationConfig, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitor
 */
export const ConflictMonitor = new ConflictMonitor$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConflictMonitorRef$Type extends MessageType<ConflictMonitorRef> {
    constructor() {
        super("c1.api.accessconflict.v1.ConflictMonitorRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ConflictMonitorRef>): ConflictMonitorRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<ConflictMonitorRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ConflictMonitorRef): ConflictMonitorRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ConflictMonitorRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessconflict.v1.ConflictMonitorRef
 */
export const ConflictMonitorRef = new ConflictMonitorRef$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AccessConflictService
 */
export const AccessConflictService = new ServiceType("c1.api.accessconflict.v1.AccessConflictService", [
    { name: "ListMonitor", options: { "authz.method": { role: "VIEWER" } }, I: ConflictMonitorListRequest, O: ConflictMonitorListResponse },
    { name: "ListMonitorWithCounts", options: { "authz.method": { role: "VIEWER" } }, I: ConflictMonitorListWithCountsRequest, O: ConflictMonitorListWithCountsResponse },
    { name: "GetMonitor", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/accessconflict/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Access_Conflict", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Access Conflict" }] }, "authz.method": { role: "VIEWER" } }, I: ConflictMonitorGetRequest, O: ConflictMonitor },
    { name: "CreateMonitor", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/accessconflict", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Access_Conflict" }], group: "Access Conflict" }] }, "authz.method": { role: "EDITOR" } }, I: ConflictMonitorCreateRequest, O: ConflictMonitor },
    { name: "DeleteMonitor", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/accessconflict/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Access_Conflict" }], group: "Access Conflict" }] }, "authz.method": { role: "EDITOR" } }, I: ConflictMonitorDeleteRequest, O: ConflictMonitorDeleteResponse },
    { name: "UpdateMonitor", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/accessconflict/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Access_Conflict" }], group: "Access Conflict" }] }, "authz.method": { role: "EDITOR" } }, I: ConflictMonitorUpdateRequest, O: ConflictMonitor },
    { name: "EnableMonitor", options: { "authz.method": { role: "EDITOR" } }, I: ConflictMonitorEnableRequest, O: ConflictMonitor },
    { name: "ForceRunMonitor", options: { "authz.method": { role: "EDITOR" } }, I: ConflictMonitorForceRunRequest, O: Empty }
]);
/**
 * @generated ServiceType for protobuf service c1.api.accessconflict.v1.AccessConflictSearchService
 */
export const AccessConflictSearchService = new ServiceType("c1.api.accessconflict.v1.AccessConflictSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: ConflictMonitorSearchRequest, O: ConflictMonitorSearchResponse },
    { name: "SearchWithCounts", options: { "authz.method": { role: "VIEWER" } }, I: ConflictMonitorSearchWithCountsRequest, O: ConflictMonitorSearchWithCountsResponse }
]);
